"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getCheckedOutProductId = getCheckedOutProductId;
exports.getPlanCosts = getPlanCosts;
exports.getProductName = getProductName;
exports.getProductTier = getProductTier;
exports.getSelectedProduct = getSelectedProduct;
exports.getSelectedProductId = getSelectedProductId;
exports.watchCheckoutEvents = watchCheckoutEvents;
exports.watchCompareUpdateEvents = watchCompareUpdateEvents;
exports.watchOpenGuidedSellingModule = watchOpenGuidedSellingModule;
exports.watchPlanRecommendationResultEvent = watchPlanRecommendationResultEvent;
exports.watchQuestionnaireEvents = watchQuestionnaireEvents;
exports.watchRecommendationResultEvent = watchRecommendationResultEvent;
exports.watchRecommendationSpecs = watchRecommendationSpecs;
exports.watchRecommendationUpdateEvents = watchRecommendationUpdateEvents;
exports.watchShareRecommendationEvents = watchShareRecommendationEvents;
exports.watchStepsEvents = watchStepsEvents;
exports.watchTaggingEvents = watchTaggingEvents;
exports.watchTransversalEvents = watchTransversalEvents;
var _effects = require("redux-saga/effects");
var _appActions = require("./appActions");
var _taggingEventsUtil = require("../utils/taggingEventsUtil");
var _services = require("../services");
var _questionnaireSelectors = require("./questionnaire/questionnaireSelectors");
var _questionnaireActions = require("./questionnaire/questionnaireActions");
var _uiActions = require("./ui/uiActions");
var _recommendationActions = require("./recommendation/recommendationActions");
var _recommendationSelectors = require("./recommendation/recommendationSelectors");
var _shareRecommendationActions = require("./shareRecommendation/shareRecommendationActions");
var _errorActions = require("./error/errorActions");
var _comparisonSelectors = require("./comparison/comparisonSelectors");
var _constants = require("../utils/constants");
var _uiSelectors = require("./ui/uiSelectors");
var _productCatalogActions = require("./productCatalog/productCatalogActions");
var _errorSelectors = require("./error/errorSelectors");
const getBasicPlanPrice = (configData, numberOfPlans) => {
  var _configData$DefaultPl, _configData$DefaultPl2, _configData$DefaultPl3, _configData$DefaultPl4;
  return {
    totalTermCost: (_configData$DefaultPl = configData === null || configData === void 0 ? void 0 : (_configData$DefaultPl2 = configData.DefaultPlan) === null || _configData$DefaultPl2 === void 0 ? void 0 : _configData$DefaultPl2.PlanPrice) !== null && _configData$DefaultPl !== void 0 ? _configData$DefaultPl : 0 * numberOfPlans,
    totalTermCostBeforeDiscount: (_configData$DefaultPl3 = configData === null || configData === void 0 ? void 0 : (_configData$DefaultPl4 = configData.DefaultPlan) === null || _configData$DefaultPl4 === void 0 ? void 0 : _configData$DefaultPl4.PlanPriceBeforeDiscount) !== null && _configData$DefaultPl3 !== void 0 ? _configData$DefaultPl3 : 0 * numberOfPlans
  };
};
const shouldCalculateBasicCost = () => {
  const taggingParser = new _services.Parsers.TaggingParser();
  return taggingParser.shouldCalculateBasicCost;
};

/**
 * Watch the questionnaire lifecycle events
 */
function* watchQuestionnaireEvents(action) {
  var _currentQuestion$titl, _currentQuestion$titl2, _currentQuestion$titl3, _currentQuestion$titl4;
  // Wait to see if any error, don't send tags if their is error in questionnaire ion view question
  if (action.type === _questionnaireActions.VIEW_QUESTION) {
    yield (0, _effects.race)({
      action: (0, _effects.take)(_errorActions.API_CALL_ERROR),
      timeout: (0, _effects.delay)(500) // 0.5s timeout
    });

    const hasError = yield (0, _effects.select)((0, _errorSelectors.selectHasError)(action.instanceId));
    if (hasError) return;
  }
  const questions = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestions)(action.instanceId));
  const answersSelections = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionnaireSelections)(action.instanceId));
  const {
    question: currentQuestion
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectViewQuestionInfo)(action.instanceId));
  const questionIndexInFlow = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionIndexInFlow)(action.instanceId));
  if (action.type === _uiActions.OPEN_GUIDED_SELLING_MODAL) {
    const isRecommendationFetched = yield (0, _effects.select)((0, _recommendationSelectors.selectIsRecommendationFetched)(action.instanceId));
    const currentPage = yield (0, _effects.select)((0, _uiSelectors.selectCurrentPage)(action.instanceId));
    if (questionIndexInFlow > 0 && currentPage == _constants.PAGES.QUESTIONNAIRE) return;
    if (isRecommendationFetched && currentPage == _constants.PAGES.RECOMMENDATION) return yield (0, _effects.put)({
      type: _recommendationActions.SET_RECOMMENDATION_TAGS,
      instanceId: action.instanceId,
      eventName: 'onReopenRecommendation'
    });
  }
  const {
    flags
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(action.instanceId));
  const pageTitle = currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$titl = currentQuestion.title) === null || _currentQuestion$titl === void 0 ? void 0 : (_currentQuestion$titl2 = _currentQuestion$titl.toLowerCase()) === null || _currentQuestion$titl2 === void 0 ? void 0 : (_currentQuestion$titl3 = _currentQuestion$titl2.trim()) === null || _currentQuestion$titl3 === void 0 ? void 0 : (_currentQuestion$titl4 = _currentQuestion$titl3.replace('?', '')) === null || _currentQuestion$titl4 === void 0 ? void 0 : _currentQuestion$titl4.replace(/ /g, '_');
  let taggingEventData = _services.analytics.getQuestionnaireEventData(questionIndexInFlow, pageTitle);
  const eventsNames = _services.analytics.getEventsName(questionIndexInFlow + 1);
  const currentEvent = eventsNames[action.type];
  const eventPayload = action.payload;
  const selectedOptionEvent = yield (0, _effects.select)((0, _questionnaireSelectors.selectViewQuestionSelections)(action.instanceId));
  const actionType = action.type;
  const isExclusiveSelection = yield (0, _effects.select)((0, _questionnaireSelectors.selectIsExclusiveSelection)(action.instanceId));
  if (currentEvent) {
    taggingEventData = {
      ...taggingEventData,
      ...currentEvent,
      selectedOptionEvent,
      currentQuestion: currentQuestion || questions[0],
      flags,
      eventPayload,
      actionType,
      isExclusiveSelection,
      questions,
      answersSelections
    };
    const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
    if (taggingEventPayload) {
      yield (0, _effects.put)({
        type: _appActions.SEND_TAGS,
        payload: taggingEventPayload,
        instanceId: action.instanceId
      });
    }
  }
}
function* getPlanCosts(currentProduct, action) {
  var _configData$basicPlan;
  const isBasicPlan = _services.configData === null || _services.configData === void 0 ? void 0 : (_configData$basicPlan = _services.configData.basicPlanIds) === null || _configData$basicPlan === void 0 ? void 0 : _configData$basicPlan.some(text => text.includes(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productId.split('-')[0]));
  let basicCosts, costs;
  if (isBasicPlan) {
    const noOfPlans = yield (0, _effects.select)((0, _recommendationSelectors.selectAdditionalPlans)(action.instanceId));
    basicCosts = getBasicPlanPrice(_services.configData, noOfPlans);
  } else {
    costs = yield (0, _effects.select)((0, _recommendationSelectors.selectPricesCosts)(action.instanceId));
  }
  return basicCosts || costs;
}

/**
 * get selected product id based on current step
 */
function* getSelectedProductId(action) {
  var _steps;
  const productSelector = {
    [_constants.PRODUCT_TYPES.HANDSET]: _recommendationSelectors.selectSelectedHandsetId,
    [_constants.PRODUCT_TYPES.AIRTIME_PLAN]: _recommendationSelectors.selectSelectedPlanId,
    [_constants.PRODUCT_TYPES.BUSINESS_SOLUTION]: _recommendationSelectors.selectSelectedBusinessSolutionId,
    [_constants.PRODUCT_TYPES.BROADBAND]: _recommendationSelectors.selectSelectedBroadbandId
  };
  const steps = yield (0, _effects.select)((0, _recommendationSelectors.selectRecommendationsSteps)(action.instanceId));
  const currentStep = yield (0, _effects.select)((0, _recommendationSelectors.selectRecommendationCurrentStep)(action.instanceId));
  const selectedProductId = (_steps = steps[currentStep - 1]) !== null && _steps !== void 0 && _steps.stepType ? yield (0, _effects.select)(productSelector[steps[currentStep - 1].stepType](action.instanceId)) : null;
  return selectedProductId;
}
function* watchRecommendationSpecs(action) {
  const areRecommendationSpecsVisible = yield (0, _effects.select)((0, _recommendationSelectors.selectAreRecommendationSpecsVisible)(action.instanceId));
  const taggingEventData = {
    eventName: 'onOpenedRecommendationSpecs',
    areRecommendationSpecsVisible
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}
/**
 * Watch on recommendation set and displayed
 */
function* watchRecommendationResultEvent(action) {
  // Wait for the costs to be updated
  yield (0, _effects.race)({
    action: (0, _effects.take)(_recommendationActions.SET_PRICES_COSTS),
    timeout: (0, _effects.delay)(1000) // 1-second timeout
  });

  const productId = yield getSelectedProductId(action);
  const currentProductName = yield getProductName(productId, action.instanceId);
  const currentProduct = yield getSelectedProduct(productId, action.instanceId);
  if (!currentProduct) return;
  let lastQuestionIndex, costsValues;
  const questionIndexInFlow = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionIndexInFlow)(action.instanceId));
  const {
    flags
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(action.instanceId));
  if (shouldCalculateBasicCost()) {
    costsValues = yield getPlanCosts(currentProduct, action);
    lastQuestionIndex = questionIndexInFlow + 2;
  }
  const questions = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestions)(action.instanceId));
  const answersSelections = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionnaireSelections)(action.instanceId));
  const taggingEventData = {
    pageName: `result:Best Match`,
    eventName: action.eventName || 'onToolResult',
    eventLabel: 'result',
    stepIndex: lastQuestionIndex || -1,
    productName: currentProductName,
    currentProduct,
    costs: costsValues,
    flags,
    questions,
    answersSelections
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}

/**
 * Watch on plan recommendation in mixed journey set and displayed
 */
function* watchPlanRecommendationResultEvent(action) {
  // Wait for the costs to be updated
  yield (0, _effects.race)({
    action: (0, _effects.take)(_recommendationActions.SET_PRICES_COSTS),
    timeout: (0, _effects.delay)(1000) // 1-second timeout
  });

  const planId = yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedPlanId)(action.instanceId));
  const currentProductName = yield getProductName(planId, action.instanceId);
  const currentProduct = yield getSelectedProduct(planId, action.instanceId);
  let lastQuestionIndex, costsValues;
  const questionIndexInFlow = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionIndexInFlow)(action.instanceId));
  const {
    flags
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(action.instanceId));
  if (shouldCalculateBasicCost()) {
    costsValues = yield getPlanCosts(currentProduct, action);
    lastQuestionIndex = questionIndexInFlow + 2;
  }
  const taggingEventData = {
    pageName: `result:Best Match`,
    eventName: 'onToolResult',
    eventLabel: 'result',
    stepIndex: lastQuestionIndex || -1,
    productName: currentProductName,
    currentProduct,
    costs: costsValues,
    flags
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}
function* getSelectedProduct(productId, instanceId) {
  let currentProductId = productId;
  if (!productId) {
    const broadbandId = yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedBroadbandId)(instanceId));
    const handsetId = yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedHandsetId)(instanceId));
    const planId = yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedPlanId)(instanceId));
    const bsId = yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedBusinessSolutionId)(instanceId));
    currentProductId = handsetId || planId || broadbandId || bsId;
  }

  // select data
  const broadbandRecommendation = yield (0, _effects.select)((0, _recommendationSelectors.selectRecommendationBroadbands)(instanceId));
  const plansRecommendation = yield (0, _effects.select)((0, _recommendationSelectors.selectRecommendationPlans)(instanceId));
  const bsRecommendation = yield (0, _effects.select)((0, _recommendationSelectors.selectRecommendationBusinessSolutions)(instanceId));
  const handsetsRecommendation = yield (0, _effects.select)((0, _recommendationSelectors.selectRecommendationHandsets)(instanceId));
  let recommendation = [...broadbandRecommendation, ...plansRecommendation, ...bsRecommendation, ...handsetsRecommendation];
  // find current selected product
  return recommendation.find(product => product.productId === currentProductId);
}
function* getProductTier(productId, instanceId) {
  const currentProduct = yield getSelectedProduct(productId, instanceId);
  if (!currentProduct) return;
  const tiers = {
    recommended: 'Best Match',
    alternative: 'Alternative',
    premium: 'Premium',
    budget: 'Budget'
  };
  return tiers[currentProduct.tier];
}
function* getProductName(productId, instanceId) {
  const currentProduct = yield getSelectedProduct(productId, instanceId);
  if (!currentProduct) return;
  const isAddonSelected = yield (0, _effects.select)((0, _recommendationSelectors.selectIsAddonSelected)(instanceId));
  if (!isAddonSelected) return currentProduct.productName.split('+')[0].trim();
  return currentProduct.productName;
}

/**
 * Watch on recommendation selection update (on tap switch)
 */
function* watchRecommendationUpdateEvents(action) {
  // Wait for the costs to be updated
  yield (0, _effects.race)({
    action: (0, _effects.take)(_recommendationActions.SET_PRICES_COSTS),
    timeout: (0, _effects.delay)(1000) // 1-second timeout
  });

  const currentProductTier = yield getProductTier(action.payload.productId, action.instanceId);
  const currentProductName = yield getProductName(action.payload.productId, action.instanceId);
  const currentProduct = yield getSelectedProduct(action.payload.productId, action.instanceId);
  const {
    flags
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(action.instanceId));
  let lastQuestionIndex, costsValues;
  const questionIndexInFlow = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionIndexInFlow)(action.instanceId));
  if (shouldCalculateBasicCost()) {
    costsValues = yield getPlanCosts(currentProduct, action);
    lastQuestionIndex = questionIndexInFlow + 2;
  }
  if (!currentProductTier) return;
  const taggingEventData = {
    pageName: `result:${currentProductTier}`,
    eventName: 'onToolResultTabSwitch',
    eventLabel: 'result',
    stepIndex: lastQuestionIndex || -1,
    productName: currentProductName,
    currentProduct,
    costs: costsValues,
    flags
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}

/**
 * Watch user interactions with steps
 */
function* watchStepsEvents(action) {
  const currentProductTier = yield getProductTier(null, action.instanceId);
  const currentProductName = yield getProductName(null, action.instanceId);
  const currentProduct = yield getSelectedProduct(null, action.instanceId);
  let lastQuestionIndex, costsValues;
  const questionIndexInFlow = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionIndexInFlow)(action.instanceId));
  if (shouldCalculateBasicCost()) {
    costsValues = yield getPlanCosts(currentProduct, action);
    lastQuestionIndex = questionIndexInFlow + 2;
  }
  const actionsEventNames = {
    [_recommendationActions.GO_TO_NEXT_STEP]: 'onToolResultNext',
    [_recommendationActions.GO_TO_PREVIOUS_STEP]: 'onToolResultBack'
  };
  const taggingEventData = {
    pageName: `result:${currentProductTier}`,
    eventName: actionsEventNames[action.type],
    eventLabel: 'result',
    stepIndex: lastQuestionIndex,
    productName: currentProductName,
    currentProduct,
    costs: costsValues
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}

/**
 * Watch send share recommendation event
 */
function* watchShareRecommendationEvents(action) {
  const currentProductTier = yield getProductTier(null, action.instanceId);
  const taggingEventData = {
    pageName: `result:${currentProductTier}`,
    eventName: 'onToolShare',
    eventLabel: 'result',
    stepIndex: -1
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}

/**
 * Watch checkout event
 */
function getCheckedOutProductId(productIds) {
  return productIds.handsetProductId || productIds.planProductId || productIds.businessSolutionId || productIds.broadbandProductId;
}
function* watchCheckoutEvents(action) {
  var _configData$basicPlan2;
  const checkoutProductIds = getCheckedOutProductId(action.productIds);
  const showPlans = yield (0, _effects.select)((0, _comparisonSelectors.selectShowPlans)(action.instanceId));
  const selectedProductId = showPlans ? yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedPlanId)(action.instanceId)) : null;
  const currentProductTier = yield getProductTier(checkoutProductIds || selectedProductId, action.instanceId);
  const currentProductName = yield getProductName(checkoutProductIds || selectedProductId, action.instanceId);
  const currentProduct = yield getSelectedProduct(checkoutProductIds || selectedProductId, action.instanceId);
  const priceCosts = yield (0, _effects.select)((0, _recommendationSelectors.selectPricesCosts)(action.instanceId));
  let lastQuestionIndex, costsValues, basicPlanPrices;
  const questionIndexInFlow = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionIndexInFlow)(action.instanceId));
  const noOfPlans = yield (0, _effects.select)((0, _recommendationSelectors.selectAdditionalPlans)(action.instanceId));
  const {
    flags
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(action.instanceId));
  const isBasicPlan = _services.configData === null || _services.configData === void 0 ? void 0 : (_configData$basicPlan2 = _services.configData.basicPlanIds) === null || _configData$basicPlan2 === void 0 ? void 0 : _configData$basicPlan2.some(text => text.includes(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productId.split('-')[0]));
  if (shouldCalculateBasicCost()) {
    basicPlanPrices = getBasicPlanPrice(_services.configData, noOfPlans);
    costsValues = isBasicPlan ? basicPlanPrices : priceCosts;
    lastQuestionIndex = questionIndexInFlow + 2;
  }
  const taggingEventData = {
    pageName: `result:${currentProductTier}`,
    eventName: 'onToolCheckout',
    eventLabel: 'result',
    stepIndex: lastQuestionIndex || -1,
    productName: currentProductName,
    currentProduct,
    costs: costsValues,
    flags,
    noOfPlans
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}

/**
 * Watch on compare update
 */
function* watchCompareUpdateEvents(action) {
  const showPlans = yield (0, _effects.select)((0, _comparisonSelectors.selectShowPlans)(action.instanceId));
  const selectedProductId = showPlans ? yield (0, _effects.select)((0, _recommendationSelectors.selectSelectedPlanId)(action.instanceId)) : null;
  const currentProductTier = yield getProductTier(selectedProductId, action.instanceId);
  const currentProductName = yield getProductName(selectedProductId, action.instanceId);
  const currentProduct = yield getSelectedProduct(selectedProductId, action.instanceId);
  const {
    flags
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(action.instanceId));
  let lastQuestionIndex;
  const questionIndexInFlow = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionIndexInFlow)(action.instanceId));
  if (shouldCalculateBasicCost()) {
    lastQuestionIndex = questionIndexInFlow + 2;
  }
  if (!currentProductTier) return;
  const taggingEventData = {
    pageName: `result:${currentProductTier}`,
    eventName: 'onToolCompare',
    eventLabel: 'result',
    stepIndex: lastQuestionIndex || -1,
    productName: currentProductName,
    currentProduct,
    flags
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}
function* watchOpenGuidedSellingModule(action) {
  const pageName = yield (0, _effects.select)((0, _uiSelectors.selectCurrentPage)(action.instanceId));
  if (pageName === _constants.PAGES.RECOMMENDATION) {
    const taggingEventData = {
      pageName: pageName,
      eventName: 'onToolClose'
    };
    const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
    if (taggingEventPayload) yield (0, _effects.put)({
      type: _appActions.SEND_TAGS,
      payload: taggingEventPayload,
      instanceId: action.instanceId
    });
  } else {
    yield watchQuestionnaireEvents(action);
  }
}
/**
 * Watch on transversal events(error message & restart confirmation message)
 */
function* watchTransversalEvents(action) {
  var _action$payload, _action$payload2, _action$payload2$acti;
  const eventsNames = _services.analytics.getEventsName();
  const currentEvent = eventsNames[action.type];
  const productId = yield getSelectedProductId(action);
  const {
    question: currentQuestion
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectViewQuestionInfo)(action.instanceId));
  const questions = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestions)(action.instanceId));
  const answersSelections = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionnaireSelections)(action.instanceId));
  const {
    flags
  } = yield (0, _effects.select)((0, _questionnaireSelectors.selectMetadata)(action.instanceId));
  const rating = yield (0, _effects.select)((0, _recommendationSelectors.selectRating)(action.instanceId));
  const currentProduct = yield getSelectedProduct(productId, action.instanceId);
  let lastQuestionIndex;
  const questionIndexInFlow = yield (0, _effects.select)((0, _questionnaireSelectors.selectQuestionIndexInFlow)(action.instanceId));
  const selectedOptionEvent = yield (0, _effects.select)((0, _questionnaireSelectors.selectViewQuestionSelections)(action.instanceId));
  lastQuestionIndex = questionIndexInFlow + 2;
  const taggingEventData = {
    ...currentEvent,
    currentQuestion: currentQuestion || questions[0],
    rating: Object.values(rating)[Object.keys(rating).length - 1],
    currentProduct,
    flags,
    costs: '',
    stepIndex: lastQuestionIndex,
    questions,
    answersSelections,
    isAddressAPIError: !!(action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.addressError),
    isRecommendationAPIError: (action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : (_action$payload2$acti = _action$payload2.actionToRetry) === null || _action$payload2$acti === void 0 ? void 0 : _action$payload2$acti.type) === _recommendationActions.FETCH_RECOMMENDATION,
    selectedOptionEvent
  };
  const taggingEventPayload = (0, _taggingEventsUtil.composeTaggingEventPayload)(taggingEventData);
  if (taggingEventPayload) yield (0, _effects.put)({
    type: _appActions.SEND_TAGS,
    payload: taggingEventPayload,
    instanceId: action.instanceId
  });
}
function* watchTaggingEvents() {
  // Watch questionnaire events
  yield (0, _effects.takeEvery)(_uiActions.OPEN_GUIDED_SELLING_MODAL, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_uiActions.CLOSE_GUIDED_SELLING_MODAL, watchOpenGuidedSellingModule);
  yield (0, _effects.takeEvery)(_uiActions.OPEN_FLOATER, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_uiActions.CLOSE_FLOATER, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.VIEW_QUESTION, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.ADD_SELECTION, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.REMOVE_SELECTION, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.REPLACE_SELECTION, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.GOTO_NEXT_QUESTION, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.GOTO_PREVIOUS_QUESTION, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_recommendationActions.GO_BACK_TO_QUESTIONNAIRE, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.RESET_QUESTIONNAIRE, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.END_QUESTIONNAIRE, watchQuestionnaireEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.SET_VIEW_QUESTION_TAGS, watchQuestionnaireEvents);

  // Watch recommendations
  yield (0, _effects.takeEvery)(_recommendationActions.SET_RECOMMENDATION_TAGS, watchRecommendationResultEvent);
  yield (0, _effects.takeEvery)(_recommendationActions.SHOW_PLAN_RECOMMENDATION, watchPlanRecommendationResultEvent);
  yield (0, _effects.takeEvery)(_recommendationActions.UPDATE_SELECTED_HANDSET, watchRecommendationUpdateEvents);
  yield (0, _effects.takeEvery)(_recommendationActions.UPDATE_SELECTED_BROADBAND, watchRecommendationUpdateEvents);
  yield (0, _effects.takeEvery)(_recommendationActions.UPDATE_SELECTED_BUSINESS_SOLUTION, watchRecommendationUpdateEvents);
  yield (0, _effects.takeEvery)(_recommendationActions.UPDATE_SELECTED_PLAN, watchRecommendationUpdateEvents);
  yield (0, _effects.takeEvery)(_recommendationActions.SET_ARE_RECOMMENDATION_SPECS_VISIBLE, watchRecommendationSpecs);
  // Watch steps
  yield (0, _effects.takeEvery)(_recommendationActions.GO_TO_NEXT_STEP, watchStepsEvents);
  yield (0, _effects.takeEvery)(_recommendationActions.GO_TO_PREVIOUS_STEP, watchStepsEvents);
  // Watch share recommendation
  yield (0, _effects.takeEvery)(_shareRecommendationActions.SEND_RECOMMENDATION_SUCCESS, watchShareRecommendationEvents);
  yield (0, _effects.takeEvery)(_recommendationActions.GO_TO_COMPARISON_PAGE, watchCompareUpdateEvents);
  // Watch checkout
  yield (0, _effects.takeEvery)(_appActions.CHECKOUT_SUCCESS, watchCheckoutEvents);
  // Watch transversal events
  yield (0, _effects.takeEvery)(_errorActions.API_CALL_ERROR, watchTransversalEvents);
  yield (0, _effects.takeEvery)(_errorActions.SET_RETRY_IN_PROGRESS, watchTransversalEvents);
  yield (0, _effects.takeEvery)(_uiActions.GO_TO_DYNAMIC_PAGE, watchTransversalEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.RESET_QUESTIONNAIRE_ON_ERROR, watchTransversalEvents);
  yield (0, _effects.takeEvery)(_questionnaireActions.RESET_QUESTIONNAIRE_ON_CONFIRM_MESSAGE, watchTransversalEvents);
  yield (0, _effects.takeEvery)(_recommendationActions.SET_RATING, watchTransversalEvents);
  yield (0, _effects.takeEvery)(_productCatalogActions.FETCH_BROADBAND_ADDRESSES_ERROR, watchTransversalEvents);
}
var _default = [watchTaggingEvents()];
exports.default = _default;